module.exports = __webpack_public_path__ + "img/dver_pvh.70aa7df6.svg";